export default __webpack_public_path__ + "static/media/x.129866ff.svg";